import React from 'react';
import { TextField, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PaymentSection = ({ 
  totalIncl, 
  invoicePaidAmount, 
  setInvoicePaidAmount,
  error = false, 
  onFocus 
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <TextField
        fullWidth
        type="number"
        label={t("paid_amount")}
        value={invoicePaidAmount}
        onChange={(e) => setInvoicePaidAmount(e.target.value)}
        onFocus={onFocus}
        placeholder="0.00"
        error={error} // ✅ This makes the field red
        helperText={error ? t("paid_amount_required") : ""} // ✅ This shows the error message
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
          },
          // ✅ Ensure red border when error
          '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: 'error.main',
            borderWidth: '2px',
          }
        }}
        InputProps={{
          startAdornment: <Box sx={{ mr: 1 }}>€</Box>
        }}
      />
      <Box sx={{ 
        mt: 2, 
        p: 1.5, 
        bgcolor: 'info.lighter', 
        borderRadius: '8px',
        border: '1px solid',
        borderColor: 'info.light'
      }}>
        <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
          {t("total_amount")}:
        </Typography>
        <Typography variant="h6" fontWeight="bold" color="info.main">
          €{totalIncl.toFixed(2)}
        </Typography>
      </Box>
    </Box>
  );
};

export default PaymentSection;